export class AdditioinaAuthMethodPageViewModel {
    constructor(options) {
        this.form$ = options.form$;

        this.methodId = ko.observable<string>(options.defaultMethodId).extend({ required: true });
        this.pin = ko.observable<string>().extend({ required: true, minLength: 6 });
        this.canShowOtherMethods = ko.observable<boolean>(options.canShowOtherMethods);

        this.canSubmit = ko.pureComputed({
            read: () => !!this.methodId() && !!this.pin(),
            deferEvaluation: true
        });

        if (!options.defaultMethodId) {
            this.showOtherMethod(true);
        }
    }

    readonly form$: JQuery;
    readonly canSubmit: KnockoutComputed<boolean>;

    methodId: KnockoutObservable<string>;
    pin: KnockoutObservable<string>;
    showOtherMethod = ko.observable(false);
    canShowOtherMethods: KnockoutObservable<boolean>;

    init() {
        ko.applyBindings(this);
    }

    onSubmit() {
        if (this.canSubmit()) {
            this.form$.submit();
        }
    }

    onMethodIdChange(methodId) {
        this.methodId(methodId);
    }

    onShowOtherMethod() {
        this.methodId(undefined);
        this.showOtherMethod(true);
    }
}
